import React from 'react';
import './Home.css'
import TypeWriterEffect from 'react-typewriter-effect';
import { FaLinkedinIn, FaGoogle, FaFacebookF } from 'react-icons/fa';
import { FiGithub } from 'react-icons/fi';
import Skill from './../Skill/Skill';
import About from './../About/About';
import Experience from './../Experience/Experience';
import AllProjects from './../HomeProjects/AllProjects';
import Education from './../Education/Education';
import Blogs from './../Blogs/Blogs';
import HomeContact from './../HomeContact/HomeContact';


const Home = () => {
    return (
        <div className='container my-5'>
            <div className='row d-flex align-items-center'>
                <div className='col-md-6 ' data-aos="fade-right">
                    <h3 className='fw-bold titleName mb-3'>Hi There, <span className='myName'> I'm Shishir Saha </span> </h3>
                         <TypeWriterEffect
                                textStyle={{
                                fontFamily: 'Red Hat Display',
                                color: '#6a5acd',
                                fontWeight: 500,
                                fontSize: '1.5em',
                                }}
                                startDelay={1000}
                                cursorColor="#3F3D56"
                                multiText={[
                                'Software Engineer',
                                'Front End Web Developer',
                                'Learning MERN Stack',
                                'System Analyst',
                                'Interested in Data Sciecne',
                                ]}
                                multiTextDelay={1000}
                                typeSpeed={80}
                                multiTextLoop={true}
                            />

                            <p className='lead text-white fw-bold mt-4 titleParagraph'>I am a hard working web developer with a flair for creating elegant solutions in the least
                            amount of time. I have gathered vast knowledge about using coding, designing, markup
                            languages and other things that are related to this sector.</p>

                            <div className='socialMedia mt-4'>
                                
                              <a href="https://github.com/Shishirsaha1530" className='socialMediaIcon faGit'>
                                  <FiGithub/>
                              </a>
                              <a href="https://www.linkedin.com/in/shishirsaha1530/" className='socialMediaIcon faLinkedin'>
                                  <FaLinkedinIn/>
                              </a>
                              <a href="/www.gmail.com" className='socialMediaIcon faGoogle'>
                                  <FaGoogle/>
                              </a>
                              <a href="/www.facebook.com/shishir.AngryMacine.5" className='socialMediaIcon faFacebook'>
                                  <FaFacebookF/>
                              </a> 
                            </div>

                            <div className='homeButton mt-4 pt-2'>
                                <a href='/' className='homeButtonStyle'> Contact Me </a>
                                <a href='https://drive.google.com/u/0/uc?id=1lGdVs3m99cftvAaTyNQ7VJ2gDupU_AXJ&export=download' className='ms-3 homeButtonStyle' target="_blank" rel="noopener noreferrer"  download> Download Resume </a>
                            </div>                          
                </div>
                <div className='col-md-6' data-aos="fade-left">
                    <img src="https://i.ibb.co/ck3Sb3Q/animation-500-krvxxfi7.gif" alt="" className='img-fluid ms-0 ms-md-3' />
                </div>
            </div>
            <Skill> </Skill>
            <About> </About>
            <Education> </Education>
            <Experience></Experience>
            <AllProjects> </AllProjects>
            <Blogs> </Blogs>
            <HomeContact></HomeContact>
        </div>
    );
};

export default Home;